import axios from "axios";
import { API_URL } from "../../constants";
import { BoardCard, BoardsHomeSections, BoardsPagination } from "./types";

interface BoardsListResponse {
  collection: BoardCard[];
  pagination: BoardsPagination;
}

/** Paginated + searchable "All boards" list (drives infinite scroll). */
export const fetchBoards = (
  companyId: string,
  params: { search?: string; page?: number; pageSize?: number }
): Promise<BoardsListResponse> => {
  const url = `${API_URL}/${companyId}/project-boards`;
  return axios.get(url, { params }).then((res) => res.data);
};

/** Pinned / starred / recent sections for the current user. */
export const fetchBoardsHome = (
  companyId: string
): Promise<BoardsHomeSections> => {
  const url = `${API_URL}/${companyId}/project-boards/home`;
  return axios.get(url).then((res) => res.data);
};

export const starBoardApi = (
  companyId: string,
  boardId: string
): Promise<{ isStarred: boolean }> => {
  const url = `${API_URL}/${companyId}/project-boards/${boardId}/star`;
  return axios.post(url).then((res) => res.data);
};

export const pinBoardApi = (
  companyId: string,
  boardId: string
): Promise<{ isPinned: boolean }> => {
  const url = `${API_URL}/${companyId}/project-boards/${boardId}/pin`;
  return axios.post(url).then((res) => res.data);
};
